<template>
  <div class="site-header__block">
    <div class="site-header ipub-shadow">
      <div class="site-header__content__logo">
        <div class="site-header__logo">
          <img :src="`${domain}/${publisherInfo.logo}`"
               alt="">
        </div>
        <div class="site-header__trigger mar-l-30"
             v-if="user.completed && !open">
          <div :class="'rotate'+(showMenus?'':' rotate-180')">
            <a @click="changeTrigger">
              <ipub-icon style="font-size:24px"
                         type="iconMenu" />
            </a>
          </div>
        </div>
      </div>
      <div class="site-header__content">
        <template v-if="!open">
          <div class="site-header__user">
            <div class="ipub-p2 fw-bd">
              <template v-if="user.lastName && user.firstName">{{user.firstName}} {{user.lastName}}</template>
              <template v-else>{{user.email}}</template>
            </div>
            <div class="ipub-p3 font-color">
              {{publisherInfo.fullName}}
            </div>
          </div>
          <ipub-dropdown>
            <div slot="title"
                 class="site-header__avatar">
              <img v-if="user.icon"
                   :src="`${domain}/${user.icon}`"
                   alt="">
              <template v-else>
                <template v-if="user.lastName && user.firstName">{{user.lastName.slice(0,1)}}</template>
                <template v-else-if="user.email">{{user.email.slice(0,1)}}</template>
              </template>
            </div>
            <div slot="menus">
              <ipub-menus>
                <ipub-menus-item>
                  <a @click="logOut">Log Out</a>
                </ipub-menus-item>
                <ipub-menus-item>
                  <router-link to="/user-manage/profile">Profile</router-link>
                </ipub-menus-item>
              </ipub-menus>
            </div>
          </ipub-dropdown>
        </template>
        <template v-else>
          <ipub-button type="primary"
                       @click="goToLogin">Sign In | Sign Up</ipub-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import user from '@/api/user'
import help from '../utils/help'
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // user: {
      //   name: 'Jane Doe',
      //   type: 'Editor',
      //   publisherName: 'IMR Press',
      //   journal: 'JIN',
      //   group: 'JIN Group'
      // }
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      showMenus: 'getShowMenus',
      publisherInfo: 'getPublisherInfo',
      domain: 'getDomain'
    })
  },
  mounted () {

  },
  methods: {
    ...mapActions(['updateShowMenus', 'updateUser']),
    changeTrigger () {
      this.updateShowMenus(!this.showMenus)
      help.doResize()
    },
    async logOut () {
      await user.logout()
      localStorage.removeItem('token')
      this.updateUser({})
      this.$router.push('/access/login')
    },
    goToLogin () {
      this.$router.push('/access/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header {
  height: 60px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  // min-width: $sm_screen;
  // min-width: 1440px;
  z-index: 999;
  &__block {
    width: 100%;
    height: 60px;
    margin-bottom: 30px;
  }
  &__content {
    width: 50%;
    display: flex;
    align-items: center;
    height: inherit;
    position: absolute;
    right: 65px;
    &__logo {
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      padding-left: 30px;
    }

    &:last-child {
      justify-content: flex-end;
    }
  }
  &__logo {
    // background: $main_color;
    height: 60px;
    color: #fff;
    font-size: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    > img {
      height: 36px;
      // filter: brightness(0) invert(1);
    }
  }
  &__trigger {
    font-size: 20px;
  }
  &__search {
    display: flex;
    justify-content: space-between;
    &__button {
      width: 40px;
      padding: 0;
      font-size: 28px;
      margin: 0 13px;
    }
  }
  &__avatar {
    width: 50px;
    height: 50px;
    background: $main_color;
    color: #fff;
    font-size: 20px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  &__user {
    text-align: right;
  }
}
</style>
